module.exports = __webpack_public_path__ + "img/tip.b4866050.png";